export const ChatWithTeamPageButton = ({ text = "Chat with our team now!" }) => (
    <a
        href="/get-in-touch"
        className="inline-flex items-center text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-semibold rounded-lg text-xl px-5 py-3 focus:outline-none"
    >{text}
    </a>
);

export const ChatWithTeamHomeButton = ({
    text = "Chat with our team now!",
}) => (
    <a
        href="https://www.mydatapulse.co.uk/appointment"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-semibold rounded-lg text-xl px-5 py-3 focus:outline-none"
    >{text}
    </a>
);

export const ChatOnWhatsAppButton = ({
    text = "Get in touch on WhatsApp now!",
}) => (
    <a
        href="https://api.whatsapp.com/send/?phone=447447164108&text=Hi%20DataPulse%20AI%20%F0%9F%91%8B%20I%27d%20love%20to%20learn%20more%20about%20what%20you%20can%20do!&type=phone_number&app_absent=0"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-semibold rounded-lg text-xl px-5 py-3 focus:outline-none"
    >
        <img
            src="/assets/images/whatsapp.svg"
            alt="WhatsApp"
            className="w-6 h-6 mr-2"
        />{text}
    </a>
);
